import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, map } from 'rxjs';

import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';
import { getPackingGift, hasStoreItems, showGiftTicket } from '@shared/shopcart/store/shopcart.selectors';

@Injectable()
export class ShopCartGiftQueryFacade {
    constructor(private readonly store: Store) { }

    public showGiftTicket$(): Observable<boolean> {
        return this.store.select(showGiftTicket);
    }

    public showGiftMessage$(): Observable<boolean> {
        return combineLatest([ this.store.select(showGiftTicket), this.store.select(getCmsConfigValue('ONLY_MESSAGE_GIFT_ENABLED')) ])
            .pipe(
                map(([packingGift, giftMessageCMS]) => giftMessageCMS && packingGift)
            );
    }

    public showGiftPackaging$(): Observable<boolean> {
        return combineLatest([ this.store.select(getPackingGift), this.store.select(getCmsConfigValue('giftpacking')), this.store.select(hasStoreItems) ])
            .pipe(map(([packingGift, giftPackingCMS, storeItems]) => giftPackingCMS && packingGift && storeItems));
    }

    public isGiftOptionEnabled$(): Observable<boolean> {
        return combineLatest([ this.showGiftPackaging$(), this.showGiftTicket$()])
            .pipe(map(([packagingGift, ticketGift]) => packagingGift || ticketGift));
    }
}
